<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="pb-20 px-4">
      <div class="container mx-auto mt-4">
        <div v-if="this.reviews.length > 0">
          <div class="md:flex md:justify-between mb-4">
            <div class="flex text-center md:text-left">
              Below is a list of reviews you have previously completed, with the most
              recent first.
            </div>
            <div class="flex justify-center md:text-right mt-4 md:mt-0">
              <StartReviewButton> Start New Review </StartReviewButton>
            </div>
          </div>
          <div class="container">
            <div v-for="review of this.reviews">
              <ReviewRow :review="review" />
            </div>
          </div>
        </div>
        <div v-else class="px-4 gap-4 bg-brand-taupe-100 p-10 rounded-md shadow-md m-4">
          <div class="flex justify-center">
            Why not start your review now and spend a few minutes thinking about the
            management of your fleet risk, to better understand if you are protecting your
            business in the best way that you can. Contact AXA or your insurance broker if
            you would like further guidance on any aspect of fleet risk management.
          </div>
          <div class="flex justify-center mt-10">
            <StartReviewButton> Start Your Fleet Risk Review </StartReviewButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "../../Shared/PageHeader.vue";
import StartReviewButton from "../../Shared/StartReviewButton.vue";
import ReviewRow from "./Components/ReviewRow.vue";

export default {
  props: {
    reviews: Object,
  },
  components: {
    PageHeader,
    StartReviewButton,
    ReviewRow,
  },
  data: function () {
    return {
      headingContent: {
        hero: {
          image: "/images/159643845_trucks_hero.jpg",
          title: "Fleet Risk Review",
          subtitle: "In association with AXA Insurance",
        },
        page: {
          title: "Your Reviews",
          subtitle: "",
        },
      },
    };
  },
};
</script>
